import { apiClient } from 'pobble-components/dist/api'

const apiGetMe = params => apiClient.get('v3/me', { params })

export { apiGetMe }
